module.exports = __webpack_public_path__ + "static/media/RamanaNaidu@3x.5cf65bcc.png";